import { Component, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { MasterService } from "@frontend/app/serivces/master.service";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { AddEventComponent } from "../add-event/add-event.component";
import { EventDetailsComponent } from "../event-details/event-details.component";
import { SVG_ICONS } from "@frontend/app/models/icons";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-event-list",
  imports: [CommonModule, SharedModule],
  templateUrl: "./event-list.component.html",
  styleUrl: "./event-list.component.scss",
})
export class EventListComponent implements OnInit {
  private masterService = inject(MasterService);
  private dialog = inject(MatDialog);
  private router = inject(Router);

  ngOnInit(): void {
    this.getEventList();
  }
  //#region variables
  eventList: any;
  displayedColumns: string[] = ["EventName", "EventType", "StartDate", "EndDate", "Venue", "City", "RegistrationLastDate", "RegistrationFee", "EventDescription", "Applied Students", "Status", "Edit", "Add", "View"];
  dataSource = new MatTableDataSource();
  length = 0;
  readonly SVG_ICONS = SVG_ICONS;
  //#endregion

  getEventList() {
    this.masterService.getEventList().subscribe(res => {
      this.eventList = res.data;
      this.dataSource.data = this.eventList;
      // this.dataSource = new MatTableDataSource(this.eventList);
      // this.length = this.eventList.length;
    });
  }

  onCreateMenu() {
    const dialogRef = this.dialog.open(AddEventComponent, {
      width: "60%",
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getEventList();
    });
  }

  onEditMenu(id: number) {
    this.dialog.open(AddEventComponent, {
      width: "60%",
      data: { eventId: id },
      panelClass: "custom-dialog-container",
      backdropClass: "custom-dialog-backdrop",
      hasBackdrop: true,
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getEventList();
    });
  }

  onRegisterMenu(id: number) {
    this.router.navigate(["/event-registration"], { queryParams: { eventId: id } });
  }

  onViewMenu(id: number) {
    this.dialog.open(EventDetailsComponent, {
      width: "60%",
      data: { eventId: id },
      panelClass: "custom-dialog-container",
      backdropClass: "custom-dialog-backdrop",
      hasBackdrop: true,
    });
  }
}
